import { useRef as l, useCallback as c } from "react";
import { getOAuthLogoutUrl as d } from "../constants/urls.js";
import { useIsOAuth2Enabled as f } from "./useIsOAuth2Enabled.js";
const p = 1e4, w = (a, o) => {
  const { OAuth2EnabledApps: i, OAuth2EnabledAppsInitialised: u } = a, r = f(i, u), m = l(), n = () => {
    clearTimeout(m.current);
    const e = document.getElementById("logout-iframe");
    e && e.remove();
  };
  return { OAuth2Logout: c(async () => {
    if (!r) return o();
    const e = (s) => {
      s.data === "logout_complete" && (o(), window.removeEventListener("message", e), n());
    };
    window.addEventListener("message", e);
    let t = document.getElementById("logout-iframe");
    t || (t = document.createElement("iframe"), t.id = "logout-iframe", t.style.display = "none", document.body.appendChild(t), m.current = setTimeout(() => {
      o(), window.removeEventListener("message", e), n();
    }, p)), t.src = d(), t.onerror = (s) => {
      console.error("There has been a problem with the logout: ", s), window.removeEventListener("message", e), n();
    };
  }, [r, o]) };
};
export {
  w as useOAuth2
};
